import React from 'react';
import { BADGE_TONE } from '../../styles/ui';

export const Badge = ({ tone = 'neutral', icon: Icon, className = '', spin = false, children }) => (
  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-semibold ${BADGE_TONE[tone] || BADGE_TONE.neutral} ${className}`}>
    {Icon && <Icon className={`h-3.5 w-3.5 ${spin ? 'animate-spin' : ''}`} />}
    {children}
  </span>
);
